<template lang="pug">

  v-card(class="pa-4")

    div(v-show="showSimpleLoading")
      SimpleLoading

    v-row(dense)
      v-col
        v-btn(color="#DEF8FF" fab dark x-small elevation="0")
          v-icon(color="primary") mdi-eye
    v-row(dense)
      v-col
        p(v-show="totalPageViews != 0" class="display-1 font-weight-bold primary--text") {{ totalPageViews }}
        p(v-show="totalPageViews == 0" class="display-0 font-weight-bold text-center grey--text") {{ $t('adsInfo.NODATA') }}
    v-row(dense)
      v-col
        h4 {{ $t('adsInfo.TITLE') }}
</template>

<script>
  import SimpleLoading from '@/components/core/SimpleLoading.vue'

  export default {
    data: function(){
          return {
            showSimpleLoading: false
          }
        },
        components: {
          SimpleLoading
        },
        computed: {
          totalPageViews(){
            return this.$store.state.adminDash.totalPageViews
          }
        },
        created(){
          //console.log(this.$store.state.adminDash.totalPageviews)
        }
      }
</script>
